import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { usePullToRefresh } from '@modules/app/composables/usePullToRefresh';

const THRESHOLD = 70;


export default /*@__PURE__*/_defineComponent({
  __name: 'PullToRefreshIndicator',
  setup(__props, { expose: __expose }) {
  __expose();

const { pullDistance, isPulling, isRefreshing } = usePullToRefresh();

const translateY = computed(() => {
  if (isRefreshing.value) return 16;
  // Map pullDistance (0 → THRESHOLD+) to translateY (-40 → 16)
  const progress = Math.min(pullDistance.value / THRESHOLD, 1);
  return -40 + progress * 56;
});

const rotation = computed(() => {
  return (pullDistance.value / THRESHOLD) * 360;
});

const opacity = computed(() => {
  return Math.min(pullDistance.value / THRESHOLD, 1);
});

const __returned__ = { pullDistance, isPulling, isRefreshing, THRESHOLD, translateY, rotation, opacity }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})